import * as types from '../actions/action-types';
import initialState from './initial-state';
import { reducerTextValues } from './reducer-text-values';

function actionTypeEndsInSuccess(type) {
    return type.substring(type.length - 8) === '_SUCCESS';
}

export default function apiStatusReducer(
    state = {
        apiCallsInProgress: initialState.apiStatus.apiCallsInProgress,
        apiErrorMessages: initialState.apiStatus.apiErrorMessages
    },
    action
) {
    if (action.type === types.BEGIN_API_CALL) {
        return {
            ...state,
            apiCallsInProgress: state.apiCallsInProgress + 1,
            apiErrorMessages: []
        };
    }

    if (action.type === types.API_CALL_ERROR) {
        return {
            ...state,
            apiCallsInProgress: state.apiCallsInProgress - 1,
            apiErrorMessages: [reducerTextValues.somethingWentWrong]
        };
    }

    if (actionTypeEndsInSuccess(action.type)) {
        return {
            ...state,
            apiCallsInProgress: state.apiCallsInProgress - 1,
            apiErrorMessage: []
        };
    }

    if (action.type === types.API_CALL_STATE_RESET) {
        return state;
    }

    return state;
}
